import { Form, Field, useFieldArray, } from 'vee-validate';
Field.compatConfig = { MODE: 3 };
Form.compatConfig = { MODE: 3 };
export * from 'vee-validate';
export { Field, Form, useFieldArray, };
